import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const routeNames: Record<string, string> = {
  "app": "Início",
  "pacientes": "Pacientes",
  "importar": "Importar",
  "relatorio": "Relatório de Resultados",
  "estatisticas": "Estatísticas",
  "minha-conta": "Minha conta",
  "dados": "Meus dados",
  "assinatura": "Minha assinatura",
  "suporte": "Suporte",
};

export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Don't show breadcrumbs on root /app route
  if (pathnames.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-4">
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        const label = routeNames[value] || value;

        // Skip UUIDs in breadcrumbs
        if (value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
          if (isLast) {
            return (
              <span key={to} className="text-foreground font-medium">
                Detalhes
              </span>
            );
          }
          return null;
        }

        return (
          <div key={to} className="flex items-center">
            {index > 0 && <ChevronRight className="h-4 w-4 mx-1" />}
            {isLast ? (
              <span className="text-foreground font-medium">{label}</span>
            ) : (
              <Link to={to} className="hover:text-foreground transition-colors">
                {label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
